import { render, staticRenderFns } from "./RecordWarehouseReceipt.vue?vue&type=template&id=8e56424c&"
import script from "./RecordWarehouseReceipt.vue?vue&type=script&lang=js&"
export * from "./RecordWarehouseReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports